import {
  GET_ALL_AGGREGATORS_SUCCESS,
  DELETE_AGGREGATOR_SUCCESS,
  CREATE_AGGREGATOR_SUCCESS,
  SET_ALL_AGGREGATORS_SUCCESS,
  SET_INDIVIDUAL_AGGREGATOR_SUCCESS
} from './actions';

const initialState = {
  aggregators: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_AGGREGATORS_SUCCESS:
    case DELETE_AGGREGATOR_SUCCESS:
    case SET_ALL_AGGREGATORS_SUCCESS:
    case SET_INDIVIDUAL_AGGREGATOR_SUCCESS:
    case CREATE_AGGREGATOR_SUCCESS:
      return {
        ...state,
        aggregators: action.data
      };
    default:
      return state;
  }
};

export default reducer;
